exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".archiveds-page[data-v-00a1b11b] {\n  width: 100%;\n  height: 100%;\n}\n.archiveds-page .header[data-v-00a1b11b] {\n  width: 100%;\n}\n.archiveds-page .header .header-title[data-v-00a1b11b] {\n  color: #0B486B;\n  font-size: 32px;\n  font-weight: bold;\n  line-height: 39px;\n  margin-bottom: 20px;\n}", ""]);

// exports
